/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * Copy Work Pattern Overrides, optionally for an employees.
 * @export
 * @interface CopyCreateWorkPatternOverrideData
 */
export interface CopyCreateWorkPatternOverrideData {
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof CopyCreateWorkPatternOverrideData
     */
    sourceStart: ShiftiePlainDate;
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof CopyCreateWorkPatternOverrideData
     */
    sourceEnd: ShiftiePlainDate;
    /**
     * Where to start copying to (inclusive)
     * @type {ShiftiePlainDate}
     * @memberof CopyCreateWorkPatternOverrideData
     */
    targetStart: ShiftiePlainDate;
    /**
     * Where to finish copying to (inclusive)
     * @type {ShiftiePlainDate}
     * @memberof CopyCreateWorkPatternOverrideData
     */
    targetEnd: ShiftiePlainDate;
    /**
     * Should each target day receive its work pattern overrides from a source day that is on the same day of the week as the target day?
     * @type {boolean}
     * @memberof CopyCreateWorkPatternOverrideData
     */
    snapSourceToTargetWeekday?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CopyCreateWorkPatternOverrideData
     */
    employeeId?: number | null;
}

/**
 * Check if a given object implements the CopyCreateWorkPatternOverrideData interface.
 */
export function instanceOfCopyCreateWorkPatternOverrideData(value: object): value is CopyCreateWorkPatternOverrideData {
    if (!('sourceStart' in value) || value['sourceStart'] === undefined) return false;
    if (!('sourceEnd' in value) || value['sourceEnd'] === undefined) return false;
    if (!('targetStart' in value) || value['targetStart'] === undefined) return false;
    if (!('targetEnd' in value) || value['targetEnd'] === undefined) return false;
    return true;
}

export function CopyCreateWorkPatternOverrideDataFromJSON(json: any): CopyCreateWorkPatternOverrideData {
    return CopyCreateWorkPatternOverrideDataFromJSONTyped(json, false);
}

export function CopyCreateWorkPatternOverrideDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyCreateWorkPatternOverrideData {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceStart': ShiftiePlainDateFromJSON(json['sourceStart']),
        'sourceEnd': ShiftiePlainDateFromJSON(json['sourceEnd']),
        'targetStart': ShiftiePlainDateFromJSON(json['targetStart']),
        'targetEnd': ShiftiePlainDateFromJSON(json['targetEnd']),
        'snapSourceToTargetWeekday': json['snapSourceToTargetWeekday'] == null ? undefined : json['snapSourceToTargetWeekday'],
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
    };
}

  export function CopyCreateWorkPatternOverrideDataToJSON(json: any): CopyCreateWorkPatternOverrideData {
      return CopyCreateWorkPatternOverrideDataToJSONTyped(json, false);
  }

  export function CopyCreateWorkPatternOverrideDataToJSONTyped(value?: CopyCreateWorkPatternOverrideData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceStart': ShiftiePlainDateToJSON(value['sourceStart']),
        'sourceEnd': ShiftiePlainDateToJSON(value['sourceEnd']),
        'targetStart': ShiftiePlainDateToJSON(value['targetStart']),
        'targetEnd': ShiftiePlainDateToJSON(value['targetEnd']),
        'snapSourceToTargetWeekday': value['snapSourceToTargetWeekday'],
        'employeeId': value['employeeId'],
    };
}

